import React from 'react';
import { Ship, Clock, ArrowRight } from 'lucide-react';
import { toBengaliNumeral } from '../utils/bengaliHelpers';
import { ShipSchedule } from '../utils/mockData';
interface TimetableCardProps {
  schedule: ShipSchedule;
  onBook: () => void;
}
export function TimetableCard({
  schedule,
  onBook
}: TimetableCardProps) {
  return <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm space-y-4" data-id="element-117">
      <div className="flex justify-between items-start" data-id="element-118">
        <div className="flex items-center space-x-3" data-id="element-119">
          <div className="bg-indigo-100 p-2 rounded-lg text-indigo-600" data-id="element-120">
            <Ship size={24} data-id="element-121" />
          </div>
          <div data-id="element-122">
            <h3 className="font-bold font-bengali text-lg" data-id="element-123">
              {schedule.operator}
            </h3>
            <span className="text-xs px-2 py-0.5 bg-gray-100 rounded text-gray-600 font-bengali" data-id="element-124">
              {schedule.class}
            </span>
          </div>
        </div>
        <div className="text-right" data-id="element-125">
          <span className="block font-bold text-xl text-[#006a4e] font-bengali" data-id="element-126">
            ৳{toBengaliNumeral(schedule.price)}
          </span>
        </div>
      </div>

      <div className="flex items-center justify-between bg-gray-50 p-3 rounded-lg" data-id="element-127">
        <div className="text-center" data-id="element-128">
          <p className="text-lg font-bold font-bengali" data-id="element-129">
            {toBengaliNumeral(schedule.departureTime)}
          </p>
          <p className="text-xs text-gray-500 font-bengali" data-id="element-130">সদরঘাট</p>
        </div>
        <div className="flex flex-col items-center px-4" data-id="element-131">
          <span className="text-xs text-gray-400 font-bengali" data-id="element-132">
            {toBengaliNumeral(schedule.duration)}
          </span>
          <div className="w-full h-[1px] bg-gray-300 w-16 my-1 relative" data-id="element-133">
            <div className="absolute right-0 -top-1 w-2 h-2 bg-gray-300 rounded-full" data-id="element-134" />
          </div>
        </div>
        <div className="text-center" data-id="element-135">
          <p className="text-lg font-bold font-bengali" data-id="element-136">
            {toBengaliNumeral(schedule.arrivalTime)}
          </p>
          <p className="text-xs text-gray-500 font-bengali" data-id="element-137">ভোলা</p>
        </div>
      </div>

      <button onClick={onBook} className="w-full py-3 bg-[#006a4e] text-white rounded-lg font-bold font-bengali flex items-center justify-center space-x-2 active:bg-[#004d38]" data-id="element-138">
        <span data-id="element-139">বুক করুন</span>
        <ArrowRight size={18} data-id="element-140" />
      </button>
    </div>;
}